type TextInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
};

export function TextInput({ label, error, className = "", ...props }: TextInputProps) {
  return (
    <label className="block">
      <span className="mb-2 block text-sm font-medium text-slate-700">{label}</span>
      <input
        {...props}
        className={`w-full rounded-2xl border px-4 py-3 text-sm outline-none transition ${
          error
            ? "border-red-300 bg-red-50 focus:border-red-500"
            : "border-slate-300 bg-white focus:border-emerald-500"
        } ${className}`}
      />
      {error ? <span className="mt-1 block text-xs text-red-600">{error}</span> : null}
    </label>
  );
}